export const capitalize = str => str.replace(/(^| )(\w)/g, s => s.toUpperCase());

export const underscoresToSpaces = str => str.replace('_', ' ');
